// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__15Xu9","description":"styles_description__3nQcy"};